import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remonte la fenêtre en haut à chaque changement de page (pathname / query).
 * Sans `hash` dans les deps : les ancres # sur la même page restent gérées par le navigateur.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
